import { usePlaylistActions } from 'app/_hooks/usePlaylistActions'
import { PlayListFormValues } from '~/features/play_list/hooks/usePlayListActionApi'
import { CreatePlayListModal } from '~/features/play_list/components/PlayListActionModal/CreatePlayListModal'
import { PlayListVideoWhichNextAction } from '~/features/play_list/components/PlayListVideoWhichNextAction'
import { SelectPlayListAction } from '~/features/play_list/components/SelectPlayListAction'
import { usePlayListVideoActionController } from '~/features/play_list/hooks/usePlayListVideoActionController'

export const PlayListVideoActionController = () => {
  const { playListVideoActionUiType: uiType, targetActionPlayListVideoInfo } = usePlaylistActions()
  const {
    onClose,
    playListInfoForView,
    startNewPlayList,
    onCreatePlayListWithAddVideo,
    onAddVideoToPlayList,
    onDeleteVideoFromPlayList,
    startAddVideoToPlayList,
    startDeletePlayListVideo,
  } = usePlayListVideoActionController()

  if (playListInfoForView === 'loading' || targetActionPlayListVideoInfo === undefined) {
    return <></>
  }

  const handleClose = () => {
    onClose()
  }

  const onChangePlayListVideo = async (
    targetPlayListId: number,
    playListVideoId: string | undefined,
  ) => {
    if (playListVideoId !== undefined) {
      onDeleteVideoFromPlayList(
        targetPlayListId.toString(),
        targetActionPlayListVideoInfo.videoId.toString(),
        targetActionPlayListVideoInfo.onFinish || (() => {}),
      )
    } else {
      onAddVideoToPlayList(
        targetPlayListId,
        targetActionPlayListVideoInfo.videoId,
        targetActionPlayListVideoInfo.onFinish || (() => {}),
      )
    }
  }

  // プレイリストの作成とその作成したプレイリストに動画を追加
  const onSavedCreatePlayListWithAddVideo = (values: PlayListFormValues) => {
    onCreatePlayListWithAddVideo(
      values,
      targetActionPlayListVideoInfo.videoId,
      targetActionPlayListVideoInfo.onFinish || (() => {}),
    )
  }

  // プレイリストから動画を削除
  const onStartDeletePlayListVideo = () => {
    if (playListInfoForView.playListId !== undefined) {
      startDeletePlayListVideo(
        playListInfoForView.playListId.toString(),
        targetActionPlayListVideoInfo.videoId.toString(),
        targetActionPlayListVideoInfo.onFinish || (() => {}),
      )
    }
  }

  return (
    <>
      <SelectPlayListAction
        isOpen={uiType === 'select' || uiType === 'createPlayList'}
        onClose={handleClose}
        playListInfoForView={playListInfoForView.allPlayListInfo}
        onChangePlayListVideo={onChangePlayListVideo}
        onClickNewPlayList={startNewPlayList}
      />
      <CreatePlayListModal
        isOpen={uiType === 'createPlayList'}
        onCancel={handleClose}
        onSave={onSavedCreatePlayListWithAddVideo}
      />
      <PlayListVideoWhichNextAction
        isOpen={uiType === 'whichNextAction'}
        onClose={handleClose}
        startAddVideoToPlayList={startAddVideoToPlayList}
        startDeletePlayListVideo={onStartDeletePlayListVideo}
      />
    </>
  )
}
